import { useSelector } from "react-redux";
import api, { makeOptions } from "@/services/api";

const useTransacoes = () => {
  const { data: user } = useSelector(state => state.auth);

  async function fetchTransacoes(params = {}) {
    try {
      const endpoint = "transacoes";
      const { data: response } = await api.get(endpoint, {
        ...makeOptions(user),
        params
      });

      if (response.success) {
        return {
          data: response.data,
          paginator: response.paginator
        };
      }

      return {
        data: [],
        paginator: null
      };
    } catch (error) {
      console.error("Erro ao buscar transações:", error);
      return {
        data: [],
        paginator: null
      };
    }
  }

  async function fetchAlunoTransacoes(alunoId, params = {}) {
    try {
      const endpoint = `alunos/${alunoId}/transacoes`;
      const { data: response } = await api.get(endpoint, {
        ...makeOptions(user),
        params
      });

      if (response.success) {
        return {
          data: response.data,
          paginator: response.paginator
        };
      }

      return {
        data: [],
        paginator: null
      };
    } catch (error) {
      console.error("Erro ao buscar transações do aluno:", error);
      return {
        data: [],
        paginator: null
      };
    }
  }

  async function approveTransacao(transacaoId) {
    try {
      const endpoint = "transacoes/aprovar";
      const { data: response } = await api.post(endpoint, { transacao_ids: [transacaoId] }, makeOptions(user));

      if (response.success) {
        return { success: true };
      }

      return { success: false, message: response.message || "Erro ao aprovar transferência" };
    } catch (error) {
      console.error("Erro ao aprovar transferência:", error);
      return { success: false, message: "Erro ao aprovar transferência" };
    }
  }

  return {
    fetchTransacoes,
    fetchAlunoTransacoes,
    approveTransacao
  };
};

export { useTransacoes };
